<template>
  <div>
    <!-- 仓库 -->
    <el-dialog :title="$t('message.warehouse')" :close-on-click-modal="false" append-to-body
      :visible.sync="warehouseDialogVisible" width="1820px" center>
      <div class="content">
        <!-- 菜单 -->
        <div class="nav">
          <!--  公共区域 -->
          <div class="item" :class="{ index: i == 2 }" @click="getIndex('2')">
            {{ $t("message.commonArea") }}
          </div>
          <!--个人区域  -->
          <div class="item" :class="{ index: i == 1 }" @click="getIndex('1')">
            {{ $t("message.personalArea") }}
          </div>
          <div class="item shelf-filter" :class="{ index: shelfRemarkFilter == '大货' }"
            @click="setShelfRemarkFilter('大货')">
            大货
          </div>
          <div class="item shelf-filter" :class="{ index: shelfRemarkFilter == 'FBA' }"
            @click="setShelfRemarkFilter('FBA')">
            FBA
          </div>
          <div class="warehouse-legend">
            <span class="legend-item">
              <i class="legend-dot empty"></i>
              白色：空库位
            </span>
            <span class="legend-item">
              <i class="legend-dot has-stock"></i>
              绿色：有货的库位
            </span>
            <span class="legend-item">
              <i class="legend-dot customer-stock"></i>
              黑色：此次上架商品对应客户的商品库位
            </span>
            <span class="legend-item">
              <i class="legend-dot same-goods"></i>
              黄色：此次上架商品同番商品库位
            </span>
          </div>
          <div class="layout-actions">
            <el-button class="layout-button" size="small" type="primary" @click="toggleLayoutEditing">
              {{ layoutEditing ? '保存布局' : '编辑布局' }}
            </el-button>
            <el-button class="layout-button" size="small" @click="resetShelfLayout">
              恢复默认布局
            </el-button>
          </div>
        </div>
        <!-- 货架列表 -->
        <div class="list">
          <div ref="shelfCanvas" class="shelf-canvas"
            :class="{ 'free-layout': freeLayoutActive, 'default-layout': !freeLayoutActive }"
            :style="freeLayoutActive ? { height: shelfCanvasHeight + 'px' } : {}">
            <!-- 单个货架；坐标和层级独立保存，允许货架互相重叠 -->
            <div class="shelves warehouse-feature-shelf" :class="{ 'layout-editing': layoutEditing }"
              v-for="shelves in list" :key="getShelfKey(shelves)" :data-shelf-key="getShelfKey(shelves)"
              :style="shelfPositionStyle(shelves)">
              <!-- 货架主体 -->
              <div class="shelves-main">
                <div class="header">
                  <!-- 编号 -->
                  <div class="key">
                    {{ $t("message.serialNumber") }}
                  </div>
                  <!-- 编号的值 -->
                  <div class="serialNumber">
                    <p>
                      {{ shelves.area_number.split("-")[0] }}-
                      <span style="color: #fa5058">{{
                        shelves.area_number.split("-")[1]
                      }}</span>
                    </p>
                  </div>
                  <!-- 使用范围 -->
                  <div class="key-range">
                    {{ $t("message.scopeOfUse") }}
                  </div>
                  <!-- 范围 -->
                  <div class="range">

                    {{
                      shelves.admin != null
                        ? shelves.admin.realname
                        : shelves.organization.name
                    }}
                  </div>
                </div>
                <!-- 每层 -->
                <div class="row" v-for="(item, index) in shelves.wms_grid" :key="index">
                  <div class="key">{{ item.floor }}层</div>

                  <!-- 每一层 -->
                  <div class="each-layer">
                    <div v-for="(items, indexs) in item.grids" :key="indexs">
                      <el-tooltip class="item" effect="dark" :content="shelves.remark + '-' + getWmsGridName(items)"
                        placement="top">
                        <div class="item" :class="gridStatusClass(items)"
                          @click="chooseOperation(items, shelves, item)">
                          {{ items.no }}
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 货架名称 -->
              <div class="shelves-name drag-handle">
                <i v-if="layoutEditing" class="el-icon-rank drag-icon"></i>
                {{ shelves.remark }}
              </div>

            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 库位商品 -->
    <el-dialog :title="$t('message.warehouseGoods')" :close-on-click-modal="false" append-to-body
      :visible.sync="warehouseGoodsDialogVisible" width="820px" center @close="resetGoods">
      <div class="content">
        <div class="table">
          <ol>
            <!--订单号  -->
            <li>{{ $t("message.orderNumber") }}</li>
            <!--番号  -->
            <li class="flex05">{{ $t("message.mash") }}</li>
            <!--图片  -->
            <li class="flex05">{{ $t("message.pic") }}</li>
            <!--库存数  -->
            <li class="flex05">{{ $t("message.numberOfInventory") }}</li>
            <!--交易号  -->
            <li>{{ $t("message.transactionNumber") }}</li>
            <!--物流号  -->
            <li>{{ $t("message.logisticsNumber") }}</li>
          </ol>
          <div class="wu" v-if="goodList == false">暂无数据</div>
          <ul v-for="(item, index) in goodList" :key="index">
            <!--订单号  -->
            <li>{{ item.order_purchase.order_sn }}</li>
            <!--番号  -->
            <li class="flex05">
              {{ item.order_purchase.order_detail.sorting }}
            </li>
            <!--图片  -->
            <li class="flex05">
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="item.order_purchase.order_detail.pic" alt="" style="width: 300px; height: 300px" />
                <a :href="`https://detail.1688.com/offer/${item.order_purchase.order_detail.goods_id}.html`"
                  target="_blank" slot="reference">
                  <img :src="item.order_purchase.order_detail.pic" style="width: 60px" alt="" />
                </a>
              </el-popover>
            </li>
            <!--库存数  -->
            <li class="flex05">{{ item.num }}</li>
            <!--交易号  -->
            <li>{{ item.order_purchase.purchase_no }}</li>
            <!--物流号  -->
            <li>
              <div class="template">
                <p v-for="(express, expressIndex) in item.order_purchase
                  .order_purchase_express" :key="expressIndex">
                  WL{{ expressIndex + 1 }}:{{ express.express_no }}
                </p>
              </div>
            </li>
          </ul>
          <div class="wu" v-if="total > goodList.length"> <el-button size="mini" type="primary"
              @click="gridStockDetail">查看更多</el-button></div>
        </div>
      </div>
    </el-dialog>
    <!-- 库位选择操作 -->
    <el-dialog title="操作选择" :close-on-click-modal="false" append-to-body :visible.sync="operationDialogVisible"
      width="420px" center>
      <div class="btn">
        <el-button type="primary" class="primary" @click="gridStockDetail" v-if="type != 7">查看库位商品</el-button>
        <el-button type="primary" @click="followUpStorage" v-if="type == 1">入库</el-button>
        <el-button type="primary" @click="boxToNormalWms" v-else-if="type == 2">入库</el-button>
        <el-button type="primary" @click="boxToChargeWms" v-else-if="type == 3">入库</el-button>
        <el-button type="primary" v-else-if="type == 4" @click="outBoxSubmit">取出</el-button>
        <!-- 批量取出 -->
        <el-button type="primary" v-else-if="type == 5" @click="outBoxBatchSubmit">放入库位</el-button>
        <!-- 多商品全部取出 -->
        <el-button type="primary" v-else-if="type == 6" @click="outBoxAllSubmit">放入库位</el-button>
        <!-- 存入长存仓库 -->
        <el-button type="primary" v-else-if="type == 7" @click="batchUpToShelf">直接上架</el-button>
        <!-- 转库单取消装箱 -->
        <el-button type="primary" v-else-if="type == 8" @click="moveOutBox">取消装箱</el-button>
        <!-- 转库单取消装箱 -->
        <el-button type="primary" v-else-if="type == 9" @click="batchMoveBackToNormal">放入库位</el-button>
        <!-- 打印上架唛头 -->
        <el-button type="primary" v-else-if="type == 10" @click="printLabel">打印上架唛头</el-button>
        <!-- 直接装箱-选择库位后标记装箱完成 -->
        <el-button type="primary" v-else-if="type == 11" @click="boxToComplete">装箱完成</el-button>
        <!-- 普通仓库库位选择：仅回填库位号给父组件 -->
        <el-button type="primary" v-else-if="type == 12" @click="selectGridNumber">选择库位</el-button>
        <!-- 长存仓库库位选择：回填库位号给父组件 -->
        <el-button type="primary" v-else-if="type == 13" @click="selectChargeGridNumber">选择库位</el-button>
        <!--  -->
        <el-button type="primary" @click="stockMove" v-else>入库</el-button>

      </div>
    </el-dialog>
  </div>
</template>
<script>
import shelfLayoutMixin from './shelfLayoutMixin'

export default {
  mixins: [shelfLayoutMixin],
  props: {
    yiku_data: { type: Array }, //移库
    up_data: { type: Array }, //上架
    boxIds: { type: Array }, //直接装箱入库
    cancelEncasementData: { type: Object }, //取出箱子商品数据
    type: { type: Number }, // 1核查-上架提交// 2 普通仓库 3 收费仓库 4 取出箱子商品 5 批量取出 6 多商品全部取出 7 存入长存仓库 8 转库单取消装箱  10 打印上架唛头
    shelf_type_set: { type: Array }, // 查看仓库类型
    userid: { type: String }, // 客户id 显示高亮
    order_purchase_ids: { type: Array }, // 同商品高亮
  },
  data() {
    return {
      warehouseDialogVisible: true, // 独立实验页面默认展示仓库弹窗
      i: [12, 13].includes(this.type) ? 1 : (localStorage.getItem('warehouseIndex') ? localStorage.getItem('warehouseIndex') : 2),
      list: [],
      warehouseGoodsDialogVisible: false, //查看商品详情
      operationDialogVisible: false, //操作弹框
      goodList: [], //订单列表
      total: 0,//订单列表总数
      page: 1,
      item: {},
      shelves: {}, /* 当前选中的货架数据 */
      shelfLayer: {}, /* 当前选中的货架层数据 */
      warehouseData: {}, // 全部货架
      shelfRemarkFilter: '', /* 货架备注筛选条件 */
    };
  },
  created() {

    let datas = {
      shelf_type_set: this.shelf_type_set,
      user_id: this.userid ? this.userid : '',
      order_purchase_id: this.order_purchase_ids ? this.order_purchase_ids : ''
    };

    this.$api.warehouseApi.wmsGridPreview(datas).then((res) => {
      this.warehouseData = res.data;
      Object.keys(this.warehouseData).forEach((area) => {
        this.initializeShelfLayouts(area)
      })
      this.getIndex(this.i);
    });
  },
  methods: {
    /**
     * 将库位数据格式化为“货架名称-层数-库位号”，用于库位悬浮提示。
     * 同时兼容直接传入库位数据和通过 wms_grid 包裹的库位数据。
     * @param {Object} data 库位数据
     * @returns {String} 格式化后的库位名称
     */
    getWmsGridName(data) {
      const gridData = data && data.wms_grid ? data.wms_grid : data
      if (!gridData || !gridData.grid_number) return ''
      const gridList = String(gridData.grid_number).split('-')
      const grid = gridList[gridList.length - 1]
      const shelfName = gridData.wms_shelf ? gridData.wms_shelf.remark : ''
      const floorList = gridData.floor_number ? String(gridData.floor_number).split('-') : []
      const floor = gridData.floor || floorList[floorList.length - 1] || ''
      return [shelfName, floor, grid].filter(item => item || item === 0).join('-')
    },
    /**
     * 切换公共区域或个人区域，并重新计算当前展示的货架列表。
     * 类型 12、13 使用固定区域，不记录用户选择；其他类型会将区域写入本地缓存。
     * @param {String|Number} i 区域标识：1 为个人区域，2 为公共区域
     */
    getIndex(i) {
      this.destroyShelfDragging()
      this.i = i;
      this.layoutEditing = false
      this.freeLayoutActive = !!this.customLayoutAreas[String(i)]
      if (![12, 13].includes(this.type)) {
        localStorage.setItem('warehouseIndex', i)
      }
      this.updateShelfCanvasHeight(i)
      this.applyShelfRemarkFilter();
    },
    /**
     * 设置货架备注筛选条件；连续点击同一个条件时取消筛选。
     * @param {String} filter 货架备注关键字，例如“大货”或“FBA”
     */
    setShelfRemarkFilter(filter) {
      this.shelfRemarkFilter = this.shelfRemarkFilter == filter ? '' : filter;
      this.applyShelfRemarkFilter();
    },
    /**
     * 根据当前区域和货架备注筛选条件生成页面展示列表。
     * 没有筛选条件时直接展示当前区域的全部货架。
     */
    applyShelfRemarkFilter() {
      const currentList = this.warehouseData[this.i] || [];
      if (!this.shelfRemarkFilter) {
        this.list = currentList;
        this.$nextTick(this.setupShelfDragging)
        return;
      }
      this.list = currentList.filter((shelves) => {
        return (shelves.remark || '').indexOf(this.shelfRemarkFilter) != -1;
      });
      this.$nextTick(this.setupShelfDragging)
    },
    /**
     * 计算库位状态对应的样式类名。
     * 颜色优先级：同番商品 > 当前客户商品 > 有货 > 空库位。
     * @param {Object} grid 库位数据
     * @returns {String} 库位状态样式类名；空字符串表示空库位
     */
    gridStatusClass(grid) {
      if (this.hasSameGoodsStock(grid)) return 'grid-same-goods';
      if (this.hasCustomerStock(grid)) return 'grid-customer-stock';
      if (this.hasGridStock(grid)) return 'grid-has-stock';
      return '';
    },
    /**
     * 判断库位中是否存在当前操作商品的同番商品。
     * 同时兼容接口中已知字段名和包含 same、goods、sorting 等关键词的扩展字段。
     * @param {Object} grid 库位数据
     * @returns {Boolean} 是否存在同番商品库存
     */
    hasSameGoodsStock(grid) {
      return this.hasTruthyField(grid, [
        'hasSameGoods',
        'has_same_goods',
        'hasSameGoodsStock',
        'has_same_goods_stock',
        'sameGoods',
        'same_goods',
        'sameGoodsStock',
        'same_goods_stock',
        'hasSameSorting',
        'has_same_sorting',
        'sameSorting',
        'same_sorting',
        'sameSortingStock',
        'same_sorting_stock',
        'isSameGoods',
        'is_same_goods',
        'sameOrderPurchase',
        'same_order_purchase',
        'sameOrderPurchaseStock',
        'same_order_purchase_stock'
      ]) || this.hasTruthyMatchingField(grid, (field) => {
        return field.indexOf('same') != -1
          && (field.indexOf('goods') != -1 || field.indexOf('sorting') != -1 || field.indexOf('stock') != -1 || field.indexOf('purchase') != -1);
      });
    },
    /**
     * 判断库位中是否存在当前客户的商品。
     * 同时识别 customer、client、user 相关的库存或商品字段。
     * @param {Object} grid 库位数据
     * @returns {Boolean} 是否存在当前客户的商品库存
     */
    hasCustomerStock(grid) {
      return this.hasTruthyField(grid, [
        'hasCustomerStock',
        'has_customer_stock',
        'customerStock',
        'customer_stock',
        'customerGoods',
        'customer_goods',
        'customerWmsStock',
        'customer_wms_stock',
        'currentCustomerStock',
        'current_customer_stock',
        'currentCustomerGoods',
        'current_customer_goods',
        'hasCustomerGoods',
        'has_customer_goods',
        'hasUserStock',
        'has_user_stock',
        'userStock',
        'user_stock',
        'userWmsStock',
        'user_wms_stock',
        'currentUserStock',
        'current_user_stock',
        'clientStock',
        'client_stock',
        'clientGoods',
        'client_goods'
      ]) || this.hasTruthyMatchingField(grid, (field) => {
        const isCustomerField = field.indexOf('customer') != -1
          || field.indexOf('client') != -1
          || field.indexOf('user') != -1;
        return isCustomerField && (field.indexOf('stock') != -1 || field.indexOf('goods') != -1 || field.indexOf('wms') != -1);
      });
    },
    /**
     * 判断库位中是否存在任意库存。
     * 优先检查已知库存字段，再检查字段名中包含 stock 的扩展字段。
     * @param {Object} grid 库位数据
     * @returns {Boolean} 库位是否有库存
     */
    hasGridStock(grid) {
      return this.hasTruthyField(grid, [
        'hasStock',
        'has_stock',
        'hasWmsStock',
        'has_wms_stock',
        'stock',
        'stock_num',
        'stockNum',
        'totalStock',
        'total_stock',
        'wmsStock',
        'wms_stock'
      ]) || this.hasTruthyMatchingField(grid, (field) => {
        return field.indexOf('stock') != -1;
      });
    },
    /**
     * 检查指定字段集合中是否至少有一个字段代表有效库存。
     * @param {Object} grid 库位数据
     * @param {String[]} fields 需要检查的字段名列表
     * @returns {Boolean} 是否命中有效库存字段
     */
    hasTruthyField(grid, fields) {
      if (!grid) return false;
      return fields.some((field) => this.isTruthyStockValue(grid[field]));
    },
    /**
     * 遍历库位全部字段，通过字段名匹配函数查找有效库存值。
     * @param {Object} grid 库位数据
     * @param {Function} matcher 字段名匹配函数，接收转成小写后的字段名
     * @returns {Boolean} 是否存在字段名和值均符合条件的字段
     */
    hasTruthyMatchingField(grid, matcher) {
      if (!grid) return false;
      return Object.keys(grid).some((field) => {
        return matcher(field.toLowerCase()) && this.isTruthyStockValue(grid[field]);
      });
    },
    /**
     * 将不同数据类型的接口字段统一判断为“是否有库存”。
     * 数字和数字字符串需大于 0，数组和对象需非空，false、空值及字符串 false 均视为无库存。
     * @param {*} value 待判断的库存字段值
     * @returns {Boolean} 该值是否代表有效库存
     */
    isTruthyStockValue(value) {
      if (value === false || value === null || value === undefined || value === '') return false;
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === 'number') return value > 0;
      if (typeof value === 'string') {
        const text = value.trim();
        if (text === '' || text.toLowerCase() === 'false') return false;
        const numberValue = Number(text);
        if (!Number.isNaN(numberValue)) return numberValue > 0;
        return true;
      }
      if (typeof value === 'object') return Object.keys(value).length > 0;
      return !!value;
    },
    /**
     * 分页查询当前选中库位的商品明细。
     * 新数据会追加到现有列表，查询成功后关闭操作弹窗并打开商品详情弹窗。
     */
    gridStockDetail() {

      this.$api.warehouseApi
        .gridStockDetail({ grid_number: this.item.grid_number, page: this.page })
        .then((res) => {
          this.goodList = [...this.goodList, ...res.data.data]
          this.total = res.data.total
          this.page++
          this.operationDialogVisible = false;
          this.warehouseGoodsDialogVisible = true;
          console.log(res);
        });
    },
    /**
     * 重置库位商品分页状态，供关闭详情或切换库位后重新查询使用。
     */
    resetGoods() {
      this.goodList = []
      this.total = 0
      this.page = 1

    },
    /**
     * 记录用户选中的库位及其货架上下文，并打开库位操作弹窗。
     * @param {Object} item 当前库位数据
     * @param {Object} shelves 当前库位所属货架数据
     * @param {Object} shelfLayer 当前库位所属货架层数据
     */
    chooseOperation(item, shelves = {}, shelfLayer = {}) {
      this.item = item;
      this.shelves = shelves;
      this.shelfLayer = shelfLayer;
      this.operationDialogVisible = true;
    },
    /**
     * 将当前库位编号回填到父页面，不直接执行入库或移库。
     * 父页面提供 submitPacking 时，会继续触发对应的业务提交。
     */
    selectGridNumber() {
      this.$parent.datas.grid_number = this.item.grid_number
      this.operationDialogVisible = false
      this.warehouseDialogVisible = false
      if (this.$parent.submitPacking) {
        this.$parent.submitPacking()
      }
    },
    /**
     * 将选中的长存仓库库位及货架上下文交给父页面处理。
     * 回调完成后关闭库位操作弹窗和当前仓库弹窗。
     */
    selectChargeGridNumber() {
      if (this.$parent.selectChargeGridNumber) {
        this.$parent.selectChargeGridNumber(this.item.grid_number, this.item, this.shelves, this.shelfLayer)
      }
      this.operationDialogVisible = false
      this.warehouseDialogVisible = false
    },
    /**
     * 将待移库数据移入当前选中的库位。
     * 接口成功后提示结果、通知父页面刷新，并关闭操作弹窗。
     */
    stockMove() {
      let datas = {
        grid_number: this.item.grid_number,
        list: this.yiku_data,
      };
      this.$api.warehouseApi.stockMove(datas).then((res) => {
        this.$message.success(res.msg);
        this.$parent.stockMoveSuccess();
        this.operationDialogVisible = false;
      });
    },
    /**
     * 提交核查商品上架。
     * 接口返回 10006 时需要用户确认是否跳过抽查，其他成功响应直接进入成功处理。
     */
    followUpStorage() {
      let datas = {
        grid_id: this.item.id,
        data: this.up_data,
      };
      this.$api.inspectionApi.followUpStorage(datas).then((res) => {
        if (res.code == 10006) {
          this.skipSpotCheck(res.msg)
          return fasle
        }
        this.$message.success(res.msg);
        this.followUpStorageSuccess()
      });
    },
    /**
     * 统一处理核查上架成功后的弹窗关闭和父页面通知。
     * 优先调用 afterFollowUpStorage；未提供时兼容调用 isAllUpStorage。
     */
    followUpStorageSuccess() {
      this.operationDialogVisible = false;
      this.warehouseDialogVisible = false;
      if (this.$parent.afterFollowUpStorage) {
        this.$parent.afterFollowUpStorage(this.item.grid_number, this.item, this.shelves, this.shelfLayer)
      } else if (this.$parent.isAllUpStorage) {
        this.$parent.isAllUpStorage()
      }
    },
    /**
     * 展示跳过检品抽查的二次确认，并在确认后携带 reconfirm 标记重新提交上架。
     * @param {String} msg 后端返回的二次确认提示内容
     */
    skipSpotCheck(msg) {
      this.$confirm(
        msg,
        this.$t("message.hint"),
        {
          confirmButtonText: '继续操作', //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let datas = {
            grid_id: this.item.id,
            data: this.up_data,
            reconfirm: 1
          };
          this.$api.inspectionApi.followUpStorage(datas).then((res) => {
            this.$message.success(res.msg);
            this.followUpStorageSuccess()
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    /**
     * 将直接装箱的箱子移入当前选中的普通仓库库位。
     * 成功后关闭相关弹窗，并通知父页面重新获取箱子列表。
     */
    boxToNormalWms() {
      let datas = {
        grid_number: this.item.grid_number,
        boxIds: this.boxIds,
      };

      this.$api.porderApi.boxToNormalWms(datas).then((res) => {
        this.$message.success(res.msg);
        this.warehouseDialogVisible = false;
        this.operationDialogVisible = false;
        this.$parent.boxList();
      });
    },
    /**
     * 二次确认后，将直接装箱的箱子移入当前选中的收费仓库库位。
     * 提示中明确收费仓库会根据客户库存体积计费；取消时不提交接口。
     */
    boxToChargeWms() {
      let datas = {
        grid_number: this.item.grid_number,
        boxIds: this.boxIds,
      };
      this.$confirm(
        this.$t(
          "商品确定转入收费仓库吗？转入收费仓库后，系统将自动根据该客户在仓库的体积进行收费！"
        ),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.porderApi.boxToChargeWms(datas).then((res) => {
            this.$message.success(res.msg);
            this.warehouseDialogVisible = false;
            this.operationDialogVisible = false;
            this.$parent.boxList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    /**
     * 使用当前库位标记直接装箱任务完成。
     * 成功后关闭弹窗，并通知父页面执行装箱完成后的刷新流程。
     */
    boxToComplete() {
      let datas = {
        ids: this.boxIds,
        grid_id: this.item.id,
        grid_number: this.item.grid_number,
      };
      this.$api.inspectionApi.toComplete(datas).then((res) => {
        this.$message.success(res.msg);
        this.operationDialogVisible = false;
        this.warehouseDialogVisible = false;
        this.$parent.markPackingFinishedSuccess();
      });
    },
    /**
     * 从箱子中取出指定商品，并把当前库位编号写入取出参数。
     * 成功后通知父页面刷新取出结果。
     */
    outBoxSubmit() {
      this.cancelEncasementData.grid_number = this.item.grid_number;
      this.$api.porderApi
        .outBoxSubmit(this.cancelEncasementData)
        .then((res) => {
          this.$message.success(res.msg);
          this.operationDialogVisible = false;
          this.$parent.takeOutSucess();
        });
    },
    /**
     * 批量取出同一商品在多个箱子中的记录。
     * 成功后关闭操作弹窗，并通知父页面刷新数据。
     */
    outBoxBatchSubmit() {
      this.cancelEncasementData.grid_number = this.item.grid_number;
      this.$api.porderApi
        .outBoxBatchSubmit(this.cancelEncasementData)
        .then((res) => {
          this.$message.success(res.msg);
          this.operationDialogVisible = false;
          this.$parent.takeOutSucess();
        });
    },
    /**
     * 一次性取出多个商品的全部装箱记录。
     * 成功后关闭操作弹窗，并通知父页面刷新数据。
     */
    outBoxAllSubmit() {
      this.cancelEncasementData.grid_number = this.item.grid_number;
      this.$api.porderApi
        .outBoxAllSubmit(this.cancelEncasementData)
        .then((res) => {
          this.$message.success(res.msg);
          this.operationDialogVisible = false;
          this.$parent.takeOutSucess();
        });
    },
    /**
     * 将待上架数据批量放入当前选中的长存仓库库位。
     * 成功后关闭弹窗，并通知父页面重新查询已完成箱子列表。
     */
    batchUpToShelf() {
      let datas = {
        ids: this.up_data,
        grid_number: this.item.grid_number,
      };
      this.$api.inventoryTransferApi.batchUpToShelf(datas).then((res) => {
        this.$message.success(res.msg);
        this.warehouseDialogVisible = false;
        this.operationDialogVisible = false;
        this.$parent.listCompleteBoxs();
      });
    },
    /**
     * 取消转库单装箱，并将商品移到当前选中的目标库位。
     * 成功后关闭操作弹窗，并通知父页面刷新取出结果。
     */
    moveOutBox() {
      this.cancelEncasementData.target_grid_number = this.item.grid_number;
      this.$api.inventoryTransferApi.outBox(this.cancelEncasementData).then((res) => {
        this.$message.success(res.msg);
        this.operationDialogVisible = false;
        this.$parent.takeOutSucess();
      });
    },

    /**
     * 将收费仓库中的指定箱子批量移回当前选中的普通仓库库位。
     * 成功后关闭弹窗，并通知父页面刷新收费仓库列表。
     */
    batchMoveBackToNormal() {
      let datas = {
        grid_number: this.item.grid_number,
        boxes: this.up_data,
      };
      this.$api.warehouseApi.batchMoveBackToNormal(datas).then((res) => {
        this.$message.success(res.msg);
        this.operationDialogVisible = false;
        this.warehouseDialogVisible = false;
        this.$parent.chargeStorageList()
      });
    },
    /**
     * 将当前库位编号写入唛头数据，并调用父页面对应的打印方法。
     * 核查详情页使用 printLabel，其他页面使用日本站的 jpPrintLabel。
     */
    printLabel() {
      this.$parent.labelData.grid_number = this.item.grid_number;
      if (this.$route.name == 'inspectDetail') {
        this.$parent.printLabel()
      } else {
        this.$parent.jpPrintLabel()
      }
      this.operationDialogVisible = false;
      this.warehouseDialogVisible = false;
    },
  },
};
</script>
<style lang='scss' scoped>
.nav {
  margin-left: 40px;
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  .item {
    width: 160px;
    height: 48px;
    line-height: 48px;
    border: 2px solid #b4272d;
    font-size: 18px;
    color: #b4272d;
    text-align: center;
    cursor: pointer;

    &:nth-child(1) {
      border-radius: 4px 0 0 4px;
      border-right: 0;
    }

    &:nth-child(2) {
      border-radius: 0 4px 4px 0;
    }
  }

  .shelf-filter {
    margin-left: 16px;
    border-radius: 4px;
  }

  .layout-actions {
    display: flex;
    flex-shrink: 0;
    margin-left: auto;
    padding-right: 40px;

    .layout-button+.layout-button {
      margin-left: 12px;
    }
  }

  .index {
    color: #fff;
    background-color: #b4272d;
  }

  .warehouse-legend {
    display: grid;
    grid-template-columns: repeat(2, max-content);
    align-items: center;
    column-gap: 18px;
    row-gap: 8px;
    margin-left: 20px;
    font-size: 14px;
    color: #333;
  }

  .legend-item {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  .legend-dot {
    width: 14px;
    height: 14px;
    margin-right: 6px;
    border: 1px solid #333;
    border-radius: 50%;
    display: inline-block;
  }

  .empty {
    background-color: #fff;
  }

  .has-stock {
    background-color: #85ce61;
    border-color: #85ce61;
  }

  .customer-stock {
    background-color: #000;
    border-color: #000;
  }

  .same-goods {
    background-color: #fff189;
    border-color: #fff189;
  }
}

.content {
  margin: 0px 15px;

  .list {
    padding: 32px 40px;
    background-color: #f8f8f8;
    border-radius: 8px;
    overflow: auto;
    height: calc(100vh - 260px);

    .shelf-canvas {
      position: relative;
      min-width: 1650px;
      min-height: 100%;

      &::after {
        display: block;
        clear: both;
        content: '';
      }
    }

    .shelves {
      width: 506px;
      background: #fff;
      border: 1px solid #333333;
      border-radius: 4px;
      float: left;
      display: flex;
      margin-right: 64px;
      margin-bottom: 24px;
      will-change: transform;

      &:nth-child(3n) {
        margin-right: 0;
      }

      .shelves-main {

        // display: flex;
        .header {
          border-bottom: 1px solid #333;
          display: flex;
          width: 100%;

          .key {
            margin-right: 1px solid #333;
            width: 64px;
          }

          .serialNumber {
            width: 122px;

            p {
              padding: 0 5px;
            }
          }

          .key-range {
            width: 80px;
          }

          .range {
            width: 160px;
          }

          div {
            border-right: 1px solid #333;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 44px;

            &:nth-last-child(1) {
              border: 0;
            }
          }
        }

        .row {
          border-bottom: 1px solid #333;
          display: flex;
          width: 100%;

          &:nth-last-child(1) {
            border: 0;
          }

          div {
            border-right: 1px solid #333;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 15px 0;

            &:nth-last-child(1) {
              border: 0;
            }
          }

          .key {
            margin-right: 1px solid #333;
            width: 64px;
          }

          .each-layer {
            width: 360px;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-items: center;
            padding: 0;

            // height: 72px;
            div {
              border: 0;
            }

            .item {
              padding: 0;
              margin: 5px 00px 5px 10px;
              width: 22px;
              height: 22px;
              border: 1px solid #333;
              cursor: pointer;
            }

            .grid-has-stock {
              background-color: #85ce61;
              border: 1px solid #85ce61;
              color: #fff;
            }

            .grid-customer-stock {
              background-color: #000;
              border: 1px solid #000;
              color: #fff;
            }

            .grid-same-goods {
              background-color: #fff189;
              border: 1px solid #fff189;
              color: #333;
            }
          }
        }
      }

      .shelves-name {
        width: 80px;
        border-left: 1px solid #333;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: 5px;

        &.drag-handle {
          position: relative;
        }

        .drag-icon {
          position: absolute;
          top: 6px;
          right: 6px;
          color: #b4272d;
          font-size: 18px;
        }
      }

      &.layout-editing .drag-handle {
        cursor: move;
        cursor: grab;
        user-select: none;
        touch-action: none;
        background-color: #fff7f7;
      }

      &.layout-editing .drag-handle:active {
        cursor: grabbing;
      }
    }

    .free-layout .shelves {
      position: absolute;
      top: 0;
      left: 0;
      float: none;
      margin: 0;
      box-sizing: border-box;

      .shelves-main {
        flex: 1;
        min-width: 0;

        .header .range,
        .row .each-layer {
          flex: 1;
          width: auto;
        }
      }

      .shelves-name {
        box-sizing: border-box;
        flex: 0 0 80px;
      }

      &.layout-editing {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
        touch-action: none;

        &::after {
          position: absolute;
          top: 0;
          right: -4px;
          width: 8px;
          height: 100%;
          border-right: 3px solid #b4272d;
          box-sizing: border-box;
          content: '';
          cursor: ew-resize;
        }
      }
    }
  }
}

.table {
  max-height: 700px;
  overflow-y: auto;

  .flex05 {
    flex: 0.5;
  }

  .template {
    width: 100%;
    text-align: left;
  }

  .wu {
    text-align: center;
    margin: 20px;
  }
}

/deep/.el-dialog {
  margin: 0 !important;
  //   position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/deep/.el-message-box__wrapper {
  z-index: 9999 !important;
}

.btn {
  text-align: center;
}
</style>
